import {Component, OnInit} from '@angular/core';
import {BmBankTransactionDomainBaseComponent} from '../bm-bank-transaction-domain-base.component';


@Component({
    selector: 'bm-bank-transaction-domain-full',
    templateUrl: 'bm-bank-transaction-domain-full.component.html',
    standalone: false
})
export class BmBankTransactionDomainFullComponent extends BmBankTransactionDomainBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
